var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var FiTupas = function () { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "594.5 854.833 300 183.333" }, { children: _jsx("switch", { children: _jsxs("g", { children: [_jsx("path", { fill: "#FFF", d: "M594.5 854.833h300v183.333h-300z" }), _jsx("path", { fill: "#003580", d: "M594.5 921.5h300v50h-300z" }), _jsx("path", { fill: "#003580", d: "M677.834 854.833h50v183.333h-50z" })] }) }) }))); };
